import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  stroke?: string;
}

const PlusIcon = (props: IProps) => (
  <svg {...props} width={props?.size || "24"} height={props?.size || "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 12H16" stroke={props?.stroke || "currentColor"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 16V8" stroke={props?.stroke || "currentColor"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default PlusIcon;
